module.exports = __webpack_public_path__ + "static/csharp-767808770e73703ccbf99ed768329284.mp4";